
import type { IBatchStore } from './batch-store-types';

export const batchHelpersMixin = {

  setTimeout(this: IBatchStore, func: any, time: number = 1000, arg: any) {
    return this.rootStore.asyncStore.setTimeout(func, time, arg);
  },

  clearTimeout(this: IBatchStore, uid: number) {
    this.rootStore.asyncStore.clearTimeout(uid);
  },

  /**
   * Check is output turn on
   */
  isOutputOn(this: IBatchStore, port: number) {
    return Number(this.outputs[port - 1]) > 0;
  },

  /**
   * Compare data and update device status only if changes are found
   */
  compareData(this: IBatchStore, data: any) {
    const _data = Array.from(this._deviceStatus.values());
    let hasChanged = false;

    data.forEach((v: any) => {
      const item = _data.find(d => d.id === v.id);
      if (!item || v.status !== item.status || v.weight !== item.weight || v.target !== item.target) {
        if (v.id) {
          this.context.onDeviceChange(v.id, v.status, v.type, v.weight, v.target);
          hasChanged = true;
          if (!item || v.status !== item.status) {
            this.context.onDeviceStatusChange(v.id, v.status, v.type);
          }
        }
      }
    });
    if (hasChanged) {
      this._deviceStatus = new Map(this.deviceStatus);
    }
  },

  getNumberOfLoadsAndQueue(this: IBatchStore) {
    return this.running.length + this.queue.length;
  },

  getNumberOfDeferredDevicesForScale(this: IBatchStore, scaleId: number) {
    return this.deferredFeedDevices.get(scaleId)?.size || 0;
  },

  setOrderId(this: IBatchStore, id: number | null) {
    this.orderId = id;
  },

  setMaterialSubstitutionData(this: IBatchStore, data: any) {
    this.materialSubstitutionData = data;
  },

};
